const chatTriggerButton = document.getElementById('chat-trigger');

if (chatTriggerButton) {
  chatTriggerButton.addEventListener('click', (ev) => {
    ev.preventDefault();
    tidioChatApi.open();
  });
}
